import { NavigateFunction } from "react-router-dom";
import { PAGE_URLS } from "@constants/common";

/**
 * Handles redirect routing based on tab identifier
 * @param redirectTab - Tab identifier from API response
 * @param navigate - React Router navigate function
 */
export const handleRedirectByTab = (
  redirectTab: string,
  navigate: NavigateFunction,
): void => {
  const redirectMap: Record<string, string> = {
    credit_upload: PAGE_URLS.ISSUE_CREDITS,
    credit_reports: PAGE_URLS.CREDIT_REPORTS,
    saved_orders: PAGE_URLS.DRAFTS,
    user_management: PAGE_URLS.USER_MANAGEMENT,
    expiry_reminders: PAGE_URLS.SEND_REMINDER,
    reports: PAGE_URLS.REPORTS,
  };

  const targetUrl = redirectMap[redirectTab] || PAGE_URLS.ISSUE_CREDITS;
  navigate(targetUrl);
};
/**
 * Finds the first accessible route based on user permissions
 * @param enabledNavigation - User permissions from profile
 * @returns The path of the first accessible route
 */
export const getFirstAccessibleRoute = (enabledNavigation: any): string => {
  if (enabledNavigation?.credit_upload) return PAGE_URLS.ISSUE_CREDITS;
  if (enabledNavigation?.credit_reports) return PAGE_URLS.CREDIT_REPORTS;
  if (enabledNavigation?.saved_orders) return PAGE_URLS.DRAFTS;
  if (enabledNavigation?.expiry_reminders) return PAGE_URLS.SEND_REMINDER;
  if (enabledNavigation?.reports) return PAGE_URLS.REPORTS;
  if (enabledNavigation?.user_management) return PAGE_URLS.USER_MANAGEMENT;
  return PAGE_URLS.SETTINGS;
};
